import React from "react";
import { Autocomplete, TextField } from "@mui/material";

function SearchableField({ label, placeholder, options, value, onChange, required, disabled }) {
    return (
        <div style={{ width: "100%" }}>
            {label && (
                <div style={{ color: "#2A2A2A", fontSize: 15, fontWeight: 500, marginBottom: 8, display: "flex" }}>
                    {label}
                    {required && <div style={{ color: "#F84242", marginLeft: "2px", marginTop: "-4px" }}>*</div>}
                </div>
            )}
            <Autocomplete
                size="small"
                disabled={disabled}
                options={Array.isArray(options) ? options : []}
                value={value || null}
                onChange={(_, picked) => onChange && onChange(picked)}
                getOptionLabel={(o) => (o && o.label) || ""}
                isOptionEqualToValue={(o, v) => o?.id === v?.id}
                noOptionsText="ไม่พบข้อมูล"
                clearOnEscape
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder={placeholder}
                        variant="outlined"
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "30px",
                                backgroundColor: "#F5F5F5",
                                fontSize: "15px",
                                "& fieldset": { borderColor: "transparent" },
                                "&:hover fieldset": { borderColor: "#25368D" },
                                "&.Mui-focused fieldset": { borderColor: "#25368D" },
                            },
                        }}
                    />
                )}
            />
        </div>
    );
}

export default SearchableField;
